import React, { Component } from 'react'
import { Container, Button, Row, Col, Label, FormGroup } from 'reactstrap'
import DataWrapper from '../../principal/containers/DataWrapper'
import { observer, inject } from 'mobx-react'
import NoticeStore from '../stores/NoticesStore'
import FormInput from "../../comum/components/FormInput"
import { Editor } from '@tinymce/tinymce-react'
import FormSelectSimples from '../../comum/components/FormSelectSimples'
import FormDateTimePicker from '../../comum/components/FormDateTimePicker'
import Footer from '../../comum/components/Footer'
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import moment from 'moment'

@inject("store")
@DataWrapper
@observer
export default class FormNotice extends Component {
  constructor(props) {
    super(props)
    this.appStore = this.props.store.appStore
    this.tituloPaginaStore = this.props.store.tituloPaginaStore
    this.controller = new NoticeStore()
    this.state = { notice: { Id: 0, Status: this.controller.selectStatus[0], Tag: this.controller.selectTag[0] }, saved: false, refreshFields: true }
    this.handleSave = this.handleSave.bind(this)
  }

  componentDidMount() {
    this.appStore.showTopbar(true)
    this.appStore.showVoltarTopBar(true, '/notices')

    const { id } = this.props.match.params
    if (id) {
      this.controller.getNotice(id).then(notice => {
        this.setState({ notice });

        this.setState({ refreshFields: false });
        setTimeout(function () {
          this.setState({ refreshFields: true });
        }.bind(this), 1)
      }
      )
    }
  }

  handleValue(field, value) {
    this.setState((prevState, props) => ({ notice: { ...prevState.notice, [field]: value } }))
  }

  async handleSave() {
    const { notice } = this.state
    if (notice.Title && notice.Body && notice.Status && notice.PublishAt && notice.Tag) {
      const { success, data } = await this.controller.saveNotice(notice)
      this.setState({ saved: success })
      if (success) {
        toast.success("Aviso salvo com sucesso.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true
        })
      } else {
        toast.error(`Erro ao salvar aviso. ${data}`, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true
        })
      }
    }
    else
      toast.error("Preencha todos os campos obrigatórios *.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true
      })
  }

  render() {
    const { notice, saved, refreshFields } = this.state
    let md = 12; let lg = 12; let xl = 12;
    if (saved)
      return <Redirect to={'/notices'} />
    else
      return (
        <Container fluid className="area-form">
          <Row>
            <FormInput
              classNames='no-uppercase'
              xs={12} sm={12} md={md} lg={lg} xl={xl}
              titulo="Titulo"
              value={notice.Title}
              obrigatorio={true}
              limiteMaximo={50}
              onChange={(event) => this.handleValue('Title', event.target.value)}
            />
          </Row>
          <Row>
            <Col xs={12} sm={12} md={md} lg={lg} xl={xl}>
              <FormGroup>
                <Label>Mensagem <span className="label-danger">*</span></Label>
                <Editor
                  id={`edit-${notice.Id}`}
                  apiKey="o1eb6grgo55puio74sv6pdhcarai0a8c0ublz43vmbz79il7"
                  value={notice.Body}
                  init={{
                    height: 500,
                    menubar: false,
                    plugins: [
                      'advlist autolink lists link',
                      'charmap print preview help',
                      'searchreplace visualblocks code',
                      'insertdatetime table paste',
                      'image '
                    ],
                    toolbar:
                      'preview | undo redo | formatselect | bold italic \
                        | image | alignleft aligncenter alignright \
                        | bullist numlist outdent indent'
                  }}
                  onEditorChange={(content, editor) => this.handleValue('Body', content)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <FormSelectSimples
              titulo="Status" xl={3} lg={3} md={3} sm={6} xs={6}
              itens={this.controller.selectStatus}
              dado={(notice.Status && notice.Status.value) ? notice.Status : this.controller.selectStatus.filter(el => el.value === notice.Status)}
              obrigatorio={true}
              onChange={(value) => this.handleValue('Status', value.value)}
              naoLimpar={false} />
            <FormSelectSimples
              titulo="Seção" xl={3} lg={3} md={3} sm={6} xs={6}
              itens={this.controller.selectTag}
              dado={(notice.Tag && notice.Tag.value) ? notice.Tag : this.controller.selectTag.filter(el => el.value === notice.Tag)}
              obrigatorio={true}
              onChange={(value) => this.handleValue('Tag', value.value)}
              naoLimpar={false} />
            {refreshFields &&
              <FormDateTimePicker titulo="Data Publicação" xl={3} lg={3} md={3} sm={6} xs={6}
                date={notice.PublishAt}
                uniqueId="dataPublish"
                obrigatorio={true}
                openUp={true}
                onChange={(value) => this.handleValue('PublishAt', value)} />
            }
            {refreshFields &&
              <FormDateTimePicker titulo="Data Expiração" xl={3} lg={3} md={3} sm={6} xs={6}
                date={notice.ExpirationAt}
                uniqueId="dataExpiration"
                openUp={true}
                onChange={(value) => this.handleValue('ExpirationAt', value)} />
            }
          </Row>
          <Footer className="footer-opcoes justify-content-between">
            <Row className="footer-content no-gutters">
              <Col xs={"auto"} xl={2} className="ml-auto ml-2 text-right">
                <Button className="btn-primary" onClick={this.handleSave}>SALVAR</Button>
              </Col>
            </Row>
          </Footer>
        </Container >
      )
  }
}


// WEBPACK FOOTER //
// ./src/modules/notices/components/FormNotice.js